import { FormArray, FormControl, FormGroup, UntypedFormGroup } from '@angular/forms';

export enum ShippingMethodSelectionType {
  FASTEST_AVAILABLE = 'fastest_available',
  CHEAPEST_AVAILABLE = 'cheapest_available',
  MANUAL = 'manual',
}

export enum TimeUnit {
  MINUTES = 'minutes',
  HOURS = 'hours',
}

export enum ExpirationBehavior {
  TIMER_DISAPPEARS = 'timer_disappears',
  SHOW_FALLBACK_MESSAGE = 'show_fallback_message',
}

export enum ComponentPlacement {
  STANDALONE = 'standalone',
  INSIDE_SHIPPING_METHOD = 'linked',
}

export enum TimerFormat {
  DIGITAL = 'digital',
  COMPACT = 'compact',
}

export type BannerVariant = 'info' | 'success' | 'warning' | 'critical';

export interface ConfigurationsFormGroup {
  shippingMethodSelectionType: FormControl<ShippingMethodSelectionType>;
  selectedShippingMethodId: FormControl<number | null>;
  minTimeThreshold: FormControl<number>;
  minTimeUnit: FormControl<TimeUnit>;
  maxTimeThreshold: FormControl<number>;
  maxTimeUnit: FormControl<TimeUnit>;
  expirationBehavior: FormControl<ExpirationBehavior>;
  fallbackMessage: FormControl<string>;
}

export interface AppearanceFormGroup {
  componentPlacement: FormControl<ComponentPlacement>;
  backgroundColor: FormControl<BannerVariant>;
  displayText: FormControl<string>;
  timerFormat: FormControl<TimerFormat>;
}

export interface TypedRuleGroup {
  entity: FormControl<string | null>;
  entityOperator: FormControl<string | null>;
  entityParams: UntypedFormGroup;
  groupIndex?: FormControl<number | undefined | null>;
}

export interface DeliveryCountdownTimerFormGroup {
  usageToken: FormControl<string>;
  title: FormControl<string>;
  internalName: FormControl<string>;
  placementMode: FormControl<string>;
  configurations: FormGroup<ConfigurationsFormGroup>;
  appearance: FormGroup<AppearanceFormGroup>;
  displayRules: FormArray<FormGroup<TypedRuleGroup>>;
}
